import { render, staticRenderFns } from "./testsocket.vue?vue&type=template&id=99abd1b8"
import script from "./testsocket.vue?vue&type=script&lang=js"
export * from "./testsocket.vue?vue&type=script&lang=js"
import style0 from "./testsocket.vue?vue&type=style&index=0&id=99abd1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports